import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import type { AdWizardFormData } from '../../-schema';

export function TargetTypeStep() {
  const { watch, setValue, formState } = useFormContext<AdWizardFormData>();
  const targetType = watch('targetType');
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold">What are you promoting?</h2>
        <p className="mt-1 text-muted-foreground">
          Choose a service or a package for this ad.
        </p>
      </div>
      <div role="radiogroup" aria-label="Ad promotes" className="grid gap-3">
        {(
          [
            ['service', 'Service', 'Promote a single treatment or service.'],
            [
              'package',
              'Packages',
              'Promote a package of services booked together.',
            ],
          ] as const
        ).map(([value, label, description]) => (
          <label
            key={value}
            className={cn(
              'flex w-full items-center justify-between gap-4 rounded-lg border p-4 text-left transition-colors cursor-pointer focus-within:ring-2 focus-within:ring-ring',
              targetType === value
                ? 'border-primary bg-primary/5'
                : 'hover:bg-muted/50'
            )}
          >
            <input
              type="radio"
              name="ad-target-type"
              value={value}
              checked={targetType === value}
              className="sr-only"
              onChange={() => {
                if (targetType !== value) {
                  setValue('serviceIds', []);
                  setValue('packageId', '');
                }
                setValue('targetType', value, { shouldValidate: true });
              }}
            />
            <span>
              <span className="block font-medium">{label}</span>
              <span className="mt-1 block text-sm text-muted-foreground">
                {description}
              </span>
            </span>
            <span
              className={cn(
                'flex size-5 shrink-0 items-center justify-center rounded-full border',
                targetType === value &&
                  'border-primary bg-primary text-primary-foreground'
              )}
            >
              {targetType === value && (
                <Check className="size-3.5" aria-hidden="true" />
              )}
            </span>
          </label>
        ))}
      </div>
      {formState.errors.targetType && (
        <p role="alert" className="text-sm text-destructive">
          Choose Service or Packages
        </p>
      )}
    </div>
  );
}
